import React, { useEffect, useState } from "react";
import {
    Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
    IconButton, Table, TableBody, TableCell, TableHead, TableRow, TextField,
    Typography, TablePagination, InputAdornment, MenuItem, Select, FormControl,
    InputLabel, Snackbar, Alert
} from "@mui/material";
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import Payroleheader from './Payroleheader';
import VisibilityIcon from "@mui/icons-material/Visibility";
import EventAvailableIcon from '@mui/icons-material/EventAvailable'; // Add this at top
import { useNavigate } from "react-router-dom";


function Staffdetails() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [staff, setStaff] = useState([]);
    const [categories, setCategories] = useState([]);
    const [formData, setFormData] = useState({
        staffcatid: "",
        staffname: "",
        mobile: "",
        address: "",
        monthlypayment: "",
        joiningdate: "",
        status: "Active",
    });
    const [editId, setEditId] = useState(null);

    // Search + Pagination
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    // Attendance Dialog
    const [attendanceOpen, setAttendanceOpen] = useState(false);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [attendanceDate, setAttendanceDate] = useState(new Date().toISOString().split('T')[0]);
    const [attendanceStatus, setAttendanceStatus] = useState("Present");
    const [attendanceData, setAttendanceData] = useState([]);

    // Snackbar for toast messages
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

    // Fetch staff + categories
    const fetchData = async () => {
        const staffSnap = await getDocs(collection(db, "staffdetails"));
        setStaff(staffSnap.docs.map((d) => ({ id: d.id, ...d.data() })));

        const catSnap = await getDocs(collection(db, "staffcategories"));
        setCategories(catSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Add/Update staff
    const handleSave = async () => {
        if (!formData.staffcatid || !formData.staffname) return;

        if (editId) {
            await updateDoc(doc(db, "staffdetails", editId), formData);
            setAlert({ open: true, message: "कर्मचारी अपडेट केला गेला!", severity: "success" });
        } else {
            await addDoc(collection(db, "staffdetails"), {
                ...formData,
                createdAt: new Date(),
            });
            setAlert({ open: true, message: "कर्मचारी Added!", severity: "success" });
        }

        setFormData({
            staffcatid: "",
            staffname: "",
            mobile: "",
            address: "",
            monthlypayment: "",
            joiningdate: "",
            status: "Active",
        });
        setEditId(null);
        setOpen(false);
        fetchData();
    };

    // Delete
    const handleDelete = async (id) => {
        await deleteDoc(doc(db, "staffdetails", id));
        setAlert({ open: true, message: "कर्मचारी हटविला गेला!", severity: "success" });
        fetchData();
    };

    // Edit
    const handleEdit = (s) => {
        setFormData(s);
        setEditId(s.id);
        setOpen(true);
    };

    // Attendance functions
    const openAttendanceDialog = async (staffMember) => {
        setSelectedStaff(staffMember);
        setAttendanceOpen(true);
        setAttendanceDate(new Date().toISOString().split('T')[0]);
        setAttendanceStatus("Present");

        // Fetch attendance for this staff
        const attSnap = await getDocs(query(
            collection(db, "attendance"),
            where("staffId", "==", staffMember.id)
        ));
        setAttendanceData(attSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    };

    const saveAttendance = async () => {
        const existing = attendanceData.find(a => a.date === attendanceDate);
        if (existing) {
            await updateDoc(doc(db, "attendance", existing.id), { status: attendanceStatus });
            setAlert({ open: true, message: "Attendance अपडेट केला गेला!", severity: "success" });
        } else {
            await addDoc(collection(db, "attendance"), {
                staffId: selectedStaff.id,
                date: attendanceDate,
                status: attendanceStatus,
                createdAt: new Date()
            });
            setAlert({ open: true, message: "Attendance Added!", severity: "success" });
        }
        setAttendanceOpen(false);
        openAttendanceDialog(selectedStaff); // Refresh attendance
    };

    const handleViewAttendance = async (staffMember) => {

        navigate(`/staff-attendance/${staffMember.id}`);

    };


    // Filter + Paginate
    const filtered = staff.filter((s) =>
        s.staffname.toLowerCase().includes(search.toLowerCase())
    );
    const paginated = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Box p={3}>
            <Payroleheader />
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => {
                        setEditId(null);
                        setFormData({
                            staffcatid: "",
                            staffname: "",
                            mobile: "",
                            address: "",
                            monthlypayment: "",
                            joiningdate: "",
                            status: "Active",
                        });
                        setOpen(true);
                    }}
                >
                    कर्मचारी जोडा
                </Button>
                <Typography variant="h5" fontWeight="bold">
                    कर्मचारी तपशील
                </Typography>
            </Box>

            {/* Search Box */}
            <TextField
                placeholder="नावाने शोधा..."
                size="small"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{ mb: 2 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
            />

            {/* Staff Table */}
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>अनुक्रमांक</TableCell>
                        <TableCell>क्रिया</TableCell>
                        <TableCell>श्रेणी</TableCell>
                        <TableCell>नाव</TableCell>
                        <TableCell>मोबाईल</TableCell>
                        <TableCell>पत्ता</TableCell>
                        <TableCell>मासिक पगार</TableCell>
                        <TableCell>जॉईनिंग तारीख</TableCell>
                        <TableCell>स्थिती</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {paginated.length > 0 ? (
                        paginated.map((s, i) => (
                            <TableRow key={s.id}>
                                <TableCell>{page * rowsPerPage + i + 1}</TableCell>
                                <TableCell>
                                    <IconButton color="primary" onClick={() => handleEdit(s)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton color="error" onClick={() => handleDelete(s.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                    <IconButton
                                        color="success"
                                        onClick={() => openAttendanceDialog(s)}
                                        title="Mark Attendance"
                                    >
                                        <EventAvailableIcon />
                                    </IconButton>
                                    <IconButton
                                        color="primary"
                                        onClick={() => handleViewAttendance(s)} // Define this function
                                    >
                                        <VisibilityIcon />
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    {categories.find((c) => c.id === s.staffcatid)?.name || "उपलब्ध नाही"}
                                </TableCell>
                                <TableCell>{s.staffname}</TableCell>
                                <TableCell>{s.mobile}</TableCell>
                                <TableCell>{s.address}</TableCell>
                                <TableCell>{s.monthlypayment}</TableCell>
                                <TableCell>{s.joiningdate}</TableCell>
                                <TableCell>{s.status}</TableCell>

                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={10}>कर्मचारी आढळले नाहीत</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>

            {/* Pagination */}
            <TablePagination
                component="div"
                count={filtered.length}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                    setRowsPerPage(parseInt(e.target.value, 10));
                    setPage(0);
                }}
            />

            {/* Add/Edit Dialog */}
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>{editId ? "कर्मचारी संपादित करा" : "कर्मचारी जोडा"}</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="normal">
                        <InputLabel>श्रेणी</InputLabel>
                        <Select
                            size="small"
                            value={formData.staffcatid}
                            onChange={(e) => setFormData({ ...formData, staffcatid: e.target.value })}
                        >
                            {categories.map((c) => (
                                <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        size="small"
                        fullWidth
                        margin="normal"
                        label="कर्मचारी नाव"
                        value={formData.staffname}
                        onChange={(e) => setFormData({ ...formData, staffname: e.target.value })}
                    />
                    <TextField
                        fullWidth
                        size="small"
                        margin="normal"
                        label="मोबाईल"
                        value={formData.mobile}
                        onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
                    />
                    <TextField
                        fullWidth
                        size="small"
                        margin="normal"
                        label="पत्ता"
                        value={formData.address}
                        onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                    />
                    <TextField
                        fullWidth
                        size="small"
                        margin="normal"
                        label="मासिक पगार"
                        type="number"
                        value={formData.monthlypayment}
                        onChange={(e) => setFormData({ ...formData, monthlypayment: e.target.value })}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        size="small"
                        type="date"
                        label="जॉईनिंग तारीख"
                        InputLabelProps={{ shrink: true }}
                        value={formData.joiningdate}
                        onChange={(e) => setFormData({ ...formData, joiningdate: e.target.value })}
                    />
                    <FormControl fullWidth margin="normal">
                        <InputLabel>स्थिती</InputLabel>
                        <Select
                            size="small"
                            value={formData.status}
                            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        >
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="error">रद्द करा</Button>
                    <Button onClick={handleSave} variant="contained">{editId ? "अपडेट करा" : "जतन करा"}</Button>
                </DialogActions>
            </Dialog>

            {/* Attendance Dialog */}
            <Dialog open={attendanceOpen} onClose={() => setAttendanceOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>Attendance: {selectedStaff?.staffname}</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        size="small"
                        margin="normal"
                        type="date"
                        label="Date"
                        InputLabelProps={{ shrink: true }}
                        value={attendanceDate}
                        onChange={(e) => setAttendanceDate(e.target.value)}
                    />
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Status</InputLabel>
                        <Select
                            size="small"
                            value={attendanceStatus}
                            onChange={(e) => setAttendanceStatus(e.target.value)}
                        >
                            <MenuItem value="Present">Present</MenuItem>
                            <MenuItem value="Absent">Absent</MenuItem>
                            <MenuItem value="Half Day">Half Day</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAttendanceOpen(false)} color="error">Cancel</Button>
                    <Button onClick={saveAttendance} variant="contained">Save</Button>
                </DialogActions>
            </Dialog>

            {/* Snackbar */}
            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                onClose={() => setAlert({ ...alert, open: false })}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={() => setAlert({ ...alert, open: false })} severity={alert.severity} sx={{ width: "100%" }}>
                    {alert.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}

export default Staffdetails;
